var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _polygon2, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _rect, _rect2, _rect3, _path22, _path23, _rect4, _rect5, _rect6, _path24, _path25, _rect7, _rect8, _rect9, _path26, _path27, _rect10, _rect11, _rect12, _path28, _path29, _rect13, _rect14, _rect15, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 924.76626,
    height: 641.9894,
    viewBox: "0 0 924.76626 641.9894",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M901.84039,677.83256c3.74046-30.07761,22.38093-59.7128,51.06588-69.50087a139.64665,139.64665,0,0,0,.00692,95.87682c4.40777,11.92286,10.55173,24.725,6.40563,36.74145-2.57964,7.477-8.89041,13.1975-15.94457,16.7744-7.0546,3.5769-14.88373,5.28172-22.61488,6.95243l-1.52153,1.25839C906.96476,738.22193,898.09992,707.91018,901.84039,677.83256Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M953.19092,608.90041a119.36031,119.36031,0,0,0-29.67278,67.17592,51.40093,51.40093,0,0,0,.58468,16.09418,29.48054,29.48054,0,0,0,7.33219,13.67368c3.30477,3.631,7.10567,6.96234,9.47027,11.33341a18.051,18.051,0,0,1,.88188,14.73616c-2.08769,5.98787-6.20242,10.86849-10.39214,15.50149-4.65189,5.14407-9.56524,10.41344-11.54265,17.23311-.23959.8263-1.50772.40622-1.26849-.41883,3.44035-11.865,14.95818-18.60464,20.451-29.29134,2.563-4.98661,3.63886-10.77584,1.236-16.03972-2.10117-4.603-6.01776-8.04173-9.39569-11.68923a31.458,31.458,0,0,1-7.66744-13.10281,47.51861,47.51861,0,0,1-1.20129-16.01232,115.8007,115.8007,0,0,1,8.45741-35.19088,121.4766,121.4766,0,0,1,21.84309-35.0047c.57116-.63958,1.45134.36648.88391,1.00188Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M923.87771,667.99227a17.90785,17.90785,0,0,1-13.6314-18.75913c.06806-.85679,1.40267-.79127,1.33452.06666a16.58227,16.58227,0,0,0,12.71571,17.424c.83627.19883.41265,1.46618-.41883,1.26849Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M929.51688,704.22384a34.51591,34.51591,0,0,0,15.41342-19.87863c.24251-.82542,1.51071-.4056,1.26849.41883A35.90175,35.90175,0,0,1,930.11768,705.417c-.74074.43939-1.33752-.75611-.6008-1.19312Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M936.9349,631.34025a10.13673,10.13673,0,0,0,9.60617-.48764c.73481-.44857,1.33082.74746.6008,1.19311a11.359,11.359,0,0,1-10.6258.563.69037.69037,0,0,1-.42483-.84366.6713.6713,0,0,1,.84366-.42482Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.342,662.054c-.45086.29314-.90172.58628-1.35313.89071a133.49486,133.49486,0,0,0-17.06883,13.32611c-.41728.37207-.83456.75542-1.24028,1.13871a140.73351,140.73351,0,0,0-30.56436,41.83882,136.67119,136.67119,0,0,0-7.48626,19.36917c-2.76241,9.166-5.02827,19.324-10.4964,26.82144a23.44535,23.44535,0,0,1-1.82656,2.25485H920.89105c-.1123-.05636-.22516-.1015-.338-.15786l-1.973.09022c.07927-.3495.169-.71029.24827-1.05979.04514-.20293.1013-.40585.14644-.60878.03358-.13529.06771-.27064.09028-.39464.011-.04508.02257-.09015.03358-.124.02257-.124.0567-.23679.07927-.3495q.744-3.0271,1.53315-6.05427c0-.01129,0-.01129.011-.02257,4.04783-15.36682,9.41411-30.53071,16.91138-44.398.22571-.41714.45086-.84557.69914-1.26271a130.41346,130.41346,0,0,1,11.71411-17.76824,115.29059,115.29059,0,0,1,7.67783-8.78262,95.87273,95.87273,0,0,1,23.99138-17.97117c17.72338-9.35762,38.2422-12.94283,57.18328-7.22677C1039.38361,661.74961,1039.85759,661.89611,1040.342,662.054Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.23094,662.68115a119.36024,119.36024,0,0,0-64.13659,35.77114,51.40084,51.40084,0,0,0-9.223,13.20232,29.48052,29.48052,0,0,0-2.37816,15.33216c.45258,4.88882,1.48168,9.83714.738,14.75085a18.051,18.051,0,0,1-8.168,12.297c-5.272,3.524-11.49586,4.94359-17.63051,6.12029-6.81135,1.30649-13.90692,2.55561-19.59168,6.8102-.68879.5155-1.4484-.58341-.76065-1.09813,9.89051-7.40226,23.14454-5.84891,33.96439-11.07458,5.04874-2.43839,9.39323-6.41306,10.64393-12.06264,1.09368-4.94031.03684-10.044-.4642-14.99a31.458,31.458,0,0,1,1.76676-15.07818,47.51855,47.51855,0,0,1,8.68137-13.5082,115.80059,115.80059,0,0,1,27.94011-23.006,121.4767,121.4767,0,0,1,38.51573-14.79824c.84111-.16679.93817,1.16642.10255,1.33212Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M981.2486,692.21411A17.90784,17.90784,0,0,1,981.659,669.029c.57019-.64313,1.59636.21271,1.02541.85669a16.58227,16.58227,0,0,0-.33766,21.56781c.548.66224-.55326,1.4191-1.09813.76065Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M963.93725,724.53816a34.51588,34.51588,0,0,0,24.27507-6.592c.69059-.513,1.45041.58571.76065,1.09813a35.90171,35.90171,0,0,1-25.27435,6.80826c-.856-.09514-.61271-1.409.23863-1.31436Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.74109,670.81085a10.13669,10.13669,0,0,0,7.96358,5.39423c.85677.08425.61256,1.39806-.23863,1.31436a11.359,11.359,0,0,1-8.82308-5.94794.69036.69036,0,0,1,.16874-.92939.67131.67131,0,0,1,.92939.16874Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M742.23915,525.98269a10.0558,10.0558,0,0,0-1.61015-15.335l9.13555-34.54737-17.60072,5.92017-5.97689,31.89915a10.11027,10.11027,0,0,0,16.05221,12.06308Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#9e616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "686.055 629.029 673.795 629.028 667.963 581.74 686.057 581.741 686.055 629.029",
    fill: "#9e616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M826.79864,769.91783l-39.53076-.00146v-.5a15.38728,15.38728,0,0,1,15.38647-15.38623h.001l24.144.001Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "628.055 629.029 615.795 629.028 609.963 581.74 628.057 581.741 628.055 629.029",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M768.79864,769.91783l-39.53076-.00146v-.5a15.38728,15.38728,0,0,1,15.38647-15.38623h.001l24.144.001Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "b1d8f474-012b-4d97-a964-9f33bafc8058-265",
    "data-name": "Path 1095",
    d: "M758.85336,473.11447l-4.706,1.3s-12.294,79.7-13.294,121.7,3,148,3,148h26l21-180,10,180h28s20-236,11-255S758.85336,473.11447,758.85336,473.11447Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "e76160c9-f3a1-43ce-a248-d388186e85bb",
    "data-name": "Ellipse 219",
    cx: 658.74398,
    cy: 179.98357,
    r: 23.49291,
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "bb67ace3-6b73-4a38-bac1-9d795c287a43-266",
    "data-name": "Path 1099",
    d: "M855.85336,363.11447l-36.464-23.83-37.786,1.488-36.75,20.342,14,78-6,45s54-6,66,3a51.277,51.277,0,0,0,24,10l-2-77Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "f7a1be30-9471-4724-82e7-c8ff3c288394-267",
    "data-name": "Path 1101",
    d: "M751.85336,360.11447l-3.778-.784-3.222,1.784s-9,12-9,23-11,117-11,117l20,9,16-83Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "a2423779-f29b-465e-aa9d-0fc12224f03e-268",
    "data-name": "Path 1104",
    d: "M816.93427,291.7643s6.14449-11.74646-7.3736-12.81432c0,0-11.5243-10.454-23.27076-1.91114,0,0-6.40715,0-9.91084,7.25044,0,0-5.03919-1.91114-6.14657,3.20358,0,0-3.68733,10.67861,0,20.28934s4.91212,10.6786,4.91212,10.6786-6.059-20.14943,8.6892-21.21729,31.252-10.28455,32.48107,1.46189,3.07866,14.64066,3.07866,14.64066S831.06737,296.56968,816.93427,291.7643Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "e9616824-6bd8-4015-8eb7-3dcfe132b2c0-269",
    "data-name": "Subtraction 1",
    d: "M513.35252,429.96937h-291v-218h291Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "f4711ed8-dad6-4be5-800d-5829f7fb3f37-270",
    "data-name": "Subtraction 1",
    d: "M513.35252,429.96937h-291v-218h291Zm-288-215v212h285v-212Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b3812a0d-69b2-4ac3-87c4-e066c2de2dfd",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fb0bff05-a63a-421c-8737-de050f830f30",
    "data-name": "Ellipse 220",
    cx: 230.14466,
    cy: 192.37305,
    r: 55.409,
    fill: "#106ff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f9b355f0-5797-4243-8ae5-6fe77774d21b-271",
    "data-name": "Path 1106",
    d: "M390.77053,316.72537h-18.839v-18.839a4.433,4.433,0,0,0-4.433-4.433h0a4.433,4.433,0,0,0-4.433,4.433v18.839h-18.839a4.433,4.433,0,0,0-4.433,4.433v0h0a4.433,4.433,0,0,0,4.433,4.433h18.839v18.839a4.433,4.433,0,0,0,4.433,4.433h0a4.433,4.433,0,0,0,4.433-4.433V325.59137h18.839a4.433,4.433,0,0,0,4.433-4.433v0h0a4.433,4.433,0,0,0-4.433-4.433h0Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M246.35588,211.0595h-108.739V129.0053h108.739Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M246.35588,211.0595h-108.739V129.0053h108.739Zm-106.739-2h104.739V131.0053h-104.739Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "a0756b3d-8076-4d61-8f2c-cdb882ad5331",
    "data-name": "Rectangle 342",
    x: 14.34201,
    y: 22.34808,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "b5dd6458-8ffa-4f7b-ade4-3f6bf4de284a",
    "data-name": "Rectangle 343",
    x: 14.34201,
    y: 38.35803,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "bf0c907d-dbb4-4364-8cdd-63eed4118a99",
    "data-name": "Rectangle 344",
    x: 14.34201,
    y: 54.36908,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M969.35588,770.0595h-108.739V688.0053h108.739Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M969.35588,770.0595h-108.739V688.0053h108.739Zm-106.739-2h104.739V690.0053h-104.739Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "b0c2ce11-0b20-4ceb-9ae2-a734f04b6c4a",
    "data-name": "Rectangle 342",
    x: 737.34201,
    y: 581.34808,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "bf5a9fda-652f-454e-a316-4f0fe63005cd",
    "data-name": "Rectangle 343",
    x: 737.34201,
    y: 597.35803,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "ad5f030a-4549-4063-8a1c-b5f384f37057",
    "data-name": "Rectangle 344",
    x: 737.34201,
    y: 613.36908,
    width: 80.054,
    height: 5.337,
    fill: "#e4e4e4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M903.31826,622.82706l-81.22118-72.3,54.55741-61.28931,81.22119,72.3Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M903.31826,622.82706l-81.22118-72.3,54.55741-61.28931,81.22119,72.3ZM824.92074,550.363l78.23344,69.64043L955.052,561.70184,876.81858,492.0614Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "b060c16b-2eb9-48d7-8f6b-fd5295a89bd0",
    "data-name": "Rectangle 342",
    x: 897.96282,
    y: 504.04622,
    width: 5.337,
    height: 80.054,
    transform: "translate(-242.1991 726.03121) rotate(-48.32574)",
    fill: "#e4e4e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "aedfd2a5-e201-47b6-a3ec-b56955ab97bd",
    "data-name": "Rectangle 343",
    x: 887.31788,
    y: 516.00464,
    width: 5.337,
    height: 80.054,
    transform: "translate(-254.69846 722.08744) rotate(-48.32574)",
    fill: "#e4e4e4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "b4720297-2a1d-43a8-8ac0-2a4c1ee9f1d2",
    "data-name": "Rectangle 344",
    x: 876.67222,
    y: 527.96389,
    width: 5.337,
    height: 80.054,
    transform: "translate(-267.19868 718.1434) rotate(-48.32574)",
    fill: "#e4e4e4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M307.92339,259.0595H186.61687V167.52189H307.92339Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M307.92339,259.0595H186.61687V167.52189H307.92339ZM188.848,256.82835H305.69224V169.753H188.848Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "e724a003-6a25-4c83-be10-32efc1fd30bf",
    "data-name": "Rectangle 342",
    x: 64.99958,
    y: 63.44755,
    width: 89.30624,
    height: 5.95382,
    fill: "#106ff4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "f16e8690-23eb-4802-9b18-78b8e9972275",
    "data-name": "Rectangle 343",
    x: 64.99958,
    y: 81.30785,
    width: 89.30624,
    height: 5.95382,
    fill: "#106ff4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "ea05cbc1-1ae7-4cbc-994d-a1c0c2d5941e",
    "data-name": "Rectangle 344",
    x: 64.99958,
    y: 99.16937,
    width: 89.30624,
    height: 5.95382,
    fill: "#106ff4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M622.73338,498.69378H437.61687V359.0053H622.73338Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M622.73338,498.69378H437.61687V359.0053H622.73338ZM441.02166,495.289H619.3286V362.41009H441.02166Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "ac8b6f6a-33b0-4e01-bc67-8452ca74a9e6",
    "data-name": "Rectangle 342",
    x: 324.41573,
    y: 268.04521,
    width: 136.28335,
    height: 9.08567,
    fill: "#106ff4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "e4f43daa-ee47-4f01-aaaf-288902bf6f27",
    "data-name": "Rectangle 343",
    x: 324.41573,
    y: 295.30043,
    width: 136.28335,
    height: 9.08567,
    fill: "#106ff4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "b40e1bee-dfb3-4798-af30-e469c9a00d65",
    "data-name": "Rectangle 344",
    x: 324.41573,
    y: 322.55752,
    width: 136.28335,
    height: 9.08567,
    fill: "#106ff4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.19244,770.9947h-480.294a1.19069,1.19069,0,0,1,0-2.38137h480.294a1.19068,1.19068,0,1,1,0,2.38137Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#cacaca"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M843.422,525.22926a10.05578,10.05578,0,0,1,5.50137-14.40454l.06041-35.73479,15.48506,10.24922-2.43139,32.363a10.11028,10.11028,0,0,1-18.61545,7.52706Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#9e616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "b2a3d507-71c0-44dd-96fb-9359ee9fed80-272",
    "data-name": "Path 1100",
    d: "M844.85336,367.11447l6.918-6.668,5.082,3.668s5,6,9,24,0,117,0,117l-22-3,3-52-9-44Z",
    transform: "translate(-137.61687 -129.0053)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstSystem);
export default __webpack_public_path__ + "static/media/first-system.c73302419658d454e98f06df348b9569.svg";
export { ForwardRef as ReactComponent };